import instance from './instance';

export const getAccounts = async ({ queryKey }) => {
  try {
    const [, query] = queryKey;
    const response = await instance.get('/v1/account/get_accounts', {
      params: query,
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching accounts data:', error);
    throw error;
  }
};

export const getStrategies = async ({ queryKey }) => {
  try {
    const [, accountName, query] = queryKey;
    const response = await instance.get(
      `/v1/account/${accountName}/get_strategies`,
      { params: query }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching strategies data:', error);
    throw error;
  }
};

export const getPortfolioPerformance = async ({ queryKey }) => {
  try {
    const [, accountName, query] = queryKey;
    const response = await instance.get(
      `/v1/account/${accountName}/get_performance`,
      { params: query }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching performance data:', error);
    throw error;
  }
};

export const getGreeks = async ({ queryKey }) => {
  try {
    const [, accountName, query] = queryKey;
    const response = await instance.get(
      `/v1/account/${accountName}/get_greeks`,
      { params: query }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching greeks data:', error);
    throw error;
  }
};

export const getGreeksPnl = async ({ queryKey }) => {
  try {
    const [, accountName, query] = queryKey;
    const response = await instance.get(
      `/v1/account/${accountName}/get_greeks_pnl`,
      { params: query }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching greeks pnl data:', error);
    throw error;
  }
};

export const getOptionsFillRate = async ({ queryKey }) => {
  try {
    const [, accountName, query] = queryKey;
    const response = await instance.get(
      `/v1/account/${accountName}/get_options_fill_rate`,
      { params: query }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching options fill rate data:', error);
    throw error;
  }
};
